<template>
    <v-app-bar :color="$route.path.includes('/document') ? '#212121' : 'white'" app flat height="60" :elevation="0"
        style="width: 100%;">

        <div class="d-flex align-center" style="width: 100%; height: 60px;">
            <!-- Logo and Brand -->
            <div class="d-flex align-center justify-space-between px-0 py-2" style="height: 57px !important;">
                <router-link :to="!$root.currentUser || !$root.currentUser.userId ? '/' : '/app' " class="d-flex align-center text-decoration-none brand-link">

                    <v-card :color="!$route.path.includes('/document') ? 'rgb(228 255 214)' : '#264C00'" class="pa-1"
                        style="border-radius: 16px !important; z-index: 2; position: relative; box-shadow: 0 3px 0 0 rgb(178 226 155) !important; margin-top: -3px !important;"
                        flat>
                        <v-img src="../../../assets/logo.png" width="38" height="38" max-width="38" contain
                            class="logo-image"></v-img>
                    </v-card>


                    <logo class="ml-3" />


                </router-link>

            </div>
            
            <span
            v-if="!$vuetify.breakpoint.xs"
            style="flex: 1"
            class="ml-3 black--text text-center">Contacto: hola@sele.es</span>

            <v-spacer v-else></v-spacer>
            <!-- Action Buttons Container -->
            <div class="d-flex align-center action-buttons">
                <!-- Theme Toggle -->
                <v-btn v-if="false" icon class="theme-toggle" @click="toggleTheme"
                    :aria-label="$vuetify.theme.dark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'">
                    <v-icon v-if="$vuetify.theme.dark">mdi-weather-sunny</v-icon>
                    <v-icon v-else>mdi-weather-night</v-icon>
                </v-btn>





                <!-- Get Started Button -->
                <v-btn 
                v-if="false"
                class="ml-4 upload-btn pl-0 pr-0" style="min-width: 44px; max-width: 44px;"
                    width="44" height="44" depressed @click="showUpload">
                    <lucide-upload :size="20" />

                </v-btn>

                <v-btn v-if="!$root.currentUser || !$root.currentUser.userId" class="primary login-btn ml-4" height="44" depressed @click="login">
          <v-icon left small class="ml-1 btn-icon">mdi-account-outline</v-icon>
          <span class="btn-text font-rubik">Iniciar sesión</span>
        </v-btn>


                <!-- Subscribe Button -->
                <v-btn v-if="!isPremium" class="ml-3 subscribe-btn font-rubik" height="44" depressed @click="openFeaturesDialog('mainbar_premium_cta')"
                    :width="$vuetify.breakpoint.xs ? 44 : 'auto'"
                        :height="$vuetify.breakpoint.xs ? 44 : 'auto'"
                        style="min-width: 44px; font-weight: 700 !important;"
                >
                    <span v-if="!$vuetify.breakpoint.xs" style="font-weight: 700 !important;">Aprovecha sin límites</span>

                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-trending-up-icon lucide-trending-up"
                        :class="{ 'ml-2': !$vuetify.breakpoint.xs }"
                    
                        >
                        <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
                        <polyline points="16 7 22 7 22 13" />
                    </svg>

                </v-btn>
             
           

                <!-- Login Button -->
                <user-button v-if="$root.currentUser" class="ml-3"></user-button>



                <!-- Mobile Menu Button -->
                <v-btn v-if="false" icon class="d-md-none ml-3 menu-button" @click="$emit('toggleDrawer')"
                    aria-label="Abrir menú">
                    <v-icon>mdi-menu</v-icon>
                </v-btn>
            </div>
        </div>

        <features-dialog :showDialog.sync="showFeaturesDialog" />
    </v-app-bar>
</template>

<script>
import UserButton from '../../profile/login/UserButton.vue'
import Logo from './Logo.vue'
import { Upload } from 'lucide-vue'
import FeaturesDialog from '../../../components/premium/FeaturesDialog.vue';


export default {
    name: 'AppBar',
    data: () => ({
        menuItems: [
            { text: 'Soluciones', id: 'solution' },
            { text: 'Ejemplos', id: 'examples' },
            { text: 'Precios', id: 'pricing' },
            { text: 'Testimonios', id: 'testimonials' },
            { text: 'Blog', id: 'blog' }
        ],
        showFeaturesDialog: false
    }),
    components: {
        UserButton,
        Logo,
        LucideUpload: Upload,
        FeaturesDialog
    },
    computed: {
        isLoggedIn() {
            return this.$root.isLoggedIn;
        },
        isPremium() {
            return this.$root.currentUser && this.$root.currentUser.premium;
        }
    },
    watch: {
        showFeaturesDialog(isShown) {
            if (!isShown && this.$route.query.premium_from) {
                const query = { ...this.$route.query };
                delete query.premium_from;
                this.$router.push({ query }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        console.error(err);
                    }
                });
            }
        },
    },
    methods: {
        scrollToSection(id) {
            if (this.$route.path !== '/') {
                this.$router.push('/');
                // return;
            }
            setTimeout(() => {
                const element = document.getElementById(id);
                if (element) {
                    const offset = -70;
                    const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
                    window.scrollTo({
                        top: elementPosition + offset,
                        behavior: 'smooth'
                    });
                }
            }, 100);
        },
        toggleTheme() {
            this.$root.isDark = !this.$root.isDark;
            this.$vuetify.theme.dark = this.$root.isDark;
            this.$cookies.set('darkMode', this.$root.isDark);
        },
        login() {
            this.$router.push({
                path: '/login',
                query: { ...this.$route.query }
            });
        },
        getStarted() {
            console.log("this.$root.currentUser", this.$root.currentUser)
            if (!this.$root.currentUser || !this.$root.currentUser.value)
                if (this.$root.currentUser)
                    this.$router.push({
                        path: '/login',
                        query: { ...this.$route.query }
                    });
                else
                    this.$router.push({
                        path: '/login',
                        query: { 
                            ...this.$route.query,
                            loginStatus: false 
                        }
                    });
            else {
                if (this.$root.currentUser.hasInfo)
                    this.$router.push({
                        path: '/app',
                        query: { ...this.$route.query }
                    });
                else
                    this.$router.push({
                        path: '/start-2',
                        query: { ...this.$route.query }
                    });
            }
        },
        showUpload() {

            if (!this.$root.currentUser || !this.$root.currentUser.userId) {
                this.$router.push('/login?upload=true');
            } else {

            // Verificar si ya estamos en la ruta con el parámetro upload=true
            const currentRoute = this.$router.currentRoute;
            const isAppPath = currentRoute.path === '/app';
            const hasUploadParam = currentRoute.query.upload === 'true';

            // Solo navegar si no estamos ya en /app con upload=true
            if (isAppPath && hasUploadParam) {
                return; // Evitar navegación redundante
            } else if (isAppPath) {
                this.$router.replace('/app?upload=true');
            } else {
                this.$router.push('/app?upload=true');
            }
        }
        },
        openFeaturesDialog(origin) {
            this.$router.push({ query: { ...this.$route.query, premium_from: origin } }).catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                    console.error(err);
                }
            });
            this.showFeaturesDialog = true;
        },
    }
}
</script>

<style scoped>
.app-bar-wrapper {
    border-radius: 0px !important;
    background: white !important;
    height: 60px !important;
    z-index: 1000 !important;
    padding: 0 !important;
    margin-bottom: 0 !important;
}

.app-bar-wrapper>>>.v-toolbar__content {
    padding: 0 !important;
}

.app-bar-content {
    padding: 0 !important;
}

.brand-link {
    position: relative;
    transition: transform 0.3s ease;
}

.brand-link:hover {
    /* No transform */
}

.logo-container {
    position: relative;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    background: linear-gradient(135deg, rgba(130, 177, 255, 0.1) 0%, rgba(68, 138, 255, 0.05) 100%);
    overflow: hidden;
    transition: all 0.3s ease;
}

.brand-link:hover .logo-container {
    box-shadow: 0 4px 12px rgba(130, 177, 255, 0.15);
}

.logo-image {
    transition: all 0.3s ease;
}

.brand-link:hover .logo-image {
    /* No transform */
}

.brand-text {
    color: #4dd453;
    font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, sans-serif !important;
    font-size: 1.7rem !important;
    font-weight: 900 !important;
    letter-spacing: -0.02;
    transition: all 0.3s ease;
}

.brand-link:hover .brand-text {
    background: linear-gradient(90deg, #4dd453, #4fee57);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.nav-links-container {
    margin: 0 16px;
}

.nav-link {
    font-size: 1rem !important;
    color: var(--v-textSecondary-base) !important;
    font-weight: 500 !important;
    text-transform: none !important;
    letter-spacing: -0.01em !important;
    padding: 0 16px !important;
    min-width: 0 !important;
    height: 44px !important;
    border-radius: 12px !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    margin: 0 4px !important;
    font-family: 'Nunito', sans-serif !important;
    position: relative;
    overflow: hidden;
}

.nav-link::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 3px;
    background: linear-gradient(90deg, #4dd453, #4fee57);
    transform: translateX(-50%);
    transition: width 0.3s ease;
    border-radius: 3px 3px 0 0;
    opacity: 0;
}

.nav-link:hover {
    background: rgba(88, 204, 2, 0.08) !important;
    color: #4dd453 !important;
}

.nav-link:hover::after {
    width: 30%;
    opacity: 1;
}

.action-buttons {
    display: flex;
    align-items: center;
}

.theme-toggle {
    width: 44px !important;
    height: 44px !important;
    border-radius: 12px !important;
    color: var(--v-textSecondary-base) !important;
    transition: all 0.3s ease !important;
    background: rgba(88, 204, 2, 0.05) !important;
}

.theme-toggle:hover {
    background: rgba(88, 204, 2, 0.1) !important;
    color: #4dd453 !important;
    box-shadow: 0 4px 8px rgba(88, 204, 2, 0.1) !important;
}

.get-started-btn {
    position: relative;
    border-radius: 12px !important;
    text-transform: none !important;
    font-weight: 600 !important;
    letter-spacing: -0.01em !important;
    box-shadow: 0 3px 0 #58a700 !important;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
    overflow: hidden;
    height: 38px !important;
    transform: translateY(0) !important;
    background: linear-gradient(90deg, #4dd453, #58cc02) !important;
}

.subscribe-btn {
    position: relative;
    border-radius: 12px !important;
    text-transform: none !important;
    font-weight: 600 !important;
    letter-spacing: -0.01em !important;
    /* box-shadow: 0 6px 0 #58a700 !important; */
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
    overflow: hidden;
    height: 39px !important;
    transform: translateY(0) !important;
    background: #4DD453 !important;
    box-shadow: 0 3px 0 #42B848 !important;
    color: white !important;
}

.btn-text,
.btn-icon {
    position: relative;
    z-index: 2;
    transition: all 0.3s ease;
}

.get-started-btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transform: translateX(-100%);
    transition: transform 0.6s;
    z-index: 1;
}

.get-started-btn:hover {
    filter: brightness(1.02);
    box-shadow: 0 4px 0 #58a700 !important;
    transform: translateY(0) !important;
}

.get-started-btn:active {
    box-shadow: 0 0 0 #58a700 !important;
    transform: translateY(4px) !important;
}

.get-started-btn:hover .btn-icon {
    /* No transform */
}

.menu-button {
    width: 44px !important;
    height: 44px !important;
    border-radius: 12px !important;
    color: var(--v-textSecondary-base) !important;
    transition: all 0.3s ease !important;
    background: rgba(88, 204, 2, 0.05) !important;
}

.menu-button:hover {
    background: rgba(88, 204, 2, 0.1) !important;
    color: #4dd453 !important;
    box-shadow: 0 4px 8px rgba(88, 204, 2, 0.1) !important;
}

/* Dark Theme Adjustments */
.theme--dark .app-bar-content {
    background: linear-gradient(to bottom right,
            rgba(30, 30, 30, 0.8),
            rgba(30, 30, 30, 0.7)) !important;
    border-color: rgba(88, 204, 2, 0.05) !important;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2) !important;
}

.theme--dark .app-bar-content:hover {
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3) !important;
    border-color: rgba(88, 204, 2, 0.1) !important;
}

.theme--dark .logo-container {
    background: linear-gradient(135deg, rgba(88, 204, 2, 0.15) 0%, rgba(88, 167, 0, 0.1) 100%);
}

.theme--dark .nav-link {
    color: rgba(255, 255, 255, 0.7) !important;
}

.theme--dark .nav-link:hover {
    background: rgba(88, 204, 2, 0.15) !important;
    color: rgba(88, 204, 2, 0.9) !important;
}

.theme--dark .theme-toggle,
.theme--dark .menu-button {
    color: rgba(255, 255, 255, 0.7) !important;
    background: rgba(88, 204, 2, 0.1) !important;
}

.theme--dark .theme-toggle:hover,
.theme--dark .menu-button:hover {
    background: rgba(88, 204, 2, 0.15) !important;
    color: rgba(88, 204, 2, 0.9) !important;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2) !important;
}

.theme--dark .login-button {
    color: rgba(255, 255, 255, 0.7) !important;
    border-color: rgba(88, 204, 2, 0.15) !important;
}

.theme--dark .login-button:hover {
    background: rgba(88, 204, 2, 0.15) !important;
    color: rgba(88, 204, 2, 0.9) !important;
    border-color: rgba(88, 204, 2, 0.25) !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
}

.theme--dark .get-started-btn {
    opacity: 0.95;
}

.theme--dark .get-started-btn:hover {
    opacity: 1;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3) !important;
}


.logo {
    border-radius: 10px;
    margin-left: -20px;
    outline: 1px solid;
    padding-left: 20px;
    padding-right: 6px;
    display: flex;
    border-bottom-left-radius: 0px !important;
    border-top-left-radius: 0px !important;
    border: none !important;
    outline: none !important;
}

.login-btn {
  position: relative;
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: -0.01em !important;
  box-shadow: 0 4px 0 #111111 !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
  overflow: hidden;
  height: 38px !important;
  transform: translateY(0) !important;
  background: linear-gradient(90deg, #313131, #464646) !important;
  padding-left: 10px !important;
}

.upload-btn {
  position: relative;
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: -0.01em !important;
  box-shadow: 0 4px 0 #111111 !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
  overflow: hidden;
  height: 38px !important;
  transform: translateY(0) !important;
  background: #ffc750 !important;
  box-shadow: 0 3px 0 #e8ab2d !important;
  color: white !important;
}

</style>